import { useAccountUpdateDetailsMutation } from '~/generated/graphql';

export function useUpdateAccountDetails() {
  const [updateAccountDetails] = useAccountUpdateDetailsMutation();

  return {
    updateAccountDetails,
  };
}
